module.exports = __webpack_public_path__ + "img/dark_checkin_at_airport.698aba8b.png";